import Layout from '@/components/layout/index.vue'
export default {
  path: 'deliverysynergy',
  name: 'Deliverysynergy',
  meta: {},
  component: Layout,
  redirect: { name: 'Deliverysynergy.ShipmentsConfiguration' },
  children: [
    {
      path: 'shipmentsConfiguration',
      name: 'Deliverysynergy.ShipmentsConfiguration',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/deliverysynergy/shipmentsConfiguration/index.vue')
    },
    {
      path: 'shipmentsConfigurations',
      name: 'Deliverysynergy.ShipmentsConfigurations',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/deliverysynergy/shipmentsConfigurations/index.vue')
    },
    {
      path: 'add',
      name: 'Deliverysynergy.Add',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/deliverysynergy/add/index.vue')
    },
    {
      path: 'orderanswer',
      name: 'Deliverysynergy.orderanswer',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/deliverysynergy/orderanswer/index.ts')
    },
    {
      path: 'deliveryschedule',
      name: 'Deliverysynergy.deliveryschedule',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/deliverysynergy/deliveryschedule/index.vue')
    },
    {
      path: 'dictionary',
      name: 'Deliverysynergy.dictionary',
      meta: {},
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/deliverysynergy/dictionary/index.ts')
    },
    {
      path: 'dictionary/add',
      name: 'Deliverysynergy.Dictionary.add',
      meta: { title: 'common.add', dep: 'Deliverysynergy.Dictionary' },
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/deliverysynergy/dictionary/add.vue')
    },
    {
      path: 'dictionary/modify/:id',
      name: 'Deliverysynergy.Dictionary.modify',
      meta: { title: 'common.add', dep: 'Deliverysynergy.Dictionary' },
      component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/deliverysynergy/dictionary/modify.vue')
    }
    // {
    //   path: 'asn',
    //   name: 'Deliverysynergy.asn',
    //   meta: {},
    //   component: () => import(/* webpackChunkName: "deliverysynergy" */ '@/views/purchaser/deliverysynergy/asn/index.ts')
    // }
  ]
}
